




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Reject080List extends Vue {}
